import {
  startAuthentication,
  startRegistration,
} from '@simplewebauthn/browser';

const webauthnKeyGesture = async (kind, optionsJSON) => {
  try {
    const response = (kind === 'register')
      ? await startRegistration({ optionsJSON })
      : await startAuthentication({ optionsJSON });

    return { response };
  } catch {
    return { cancelled: true };
  }
};

export default webauthnKeyGesture;
